import { Button, TextInput } from "risa-oasis-ui_v2";
import FileIcon from "../../../../../../../svg/fileIcon";

interface InputPanelProps {
  identifierId: string;
  onIdentifierChange: (value: string) => void;
  jsonInput: string;
  jsonParseError: string;
  isFetching: boolean;
  isRunning: boolean;
  isJsonValid: boolean;
  onJsonInputChange: (value: string) => void;
  onFetch: () => void;
  onRun: () => void;
  onReset: () => void;
}

const InputPanel = ({
  identifierId,
  onIdentifierChange,
  jsonInput,
  jsonParseError,
  isFetching,
  isRunning,
  isJsonValid,
  onJsonInputChange,
  onFetch,
  onRun,
  onReset,
}: InputPanelProps) => {
  return (
    <div className="flex flex-col rounded-lg border border-primaryGray-14 bg-white shadow-sm">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-gray-100 px-4 py-3">
        <div className="flex items-center gap-2">
          <FileIcon width={14} height={18} strokeColor="#374151" />
          <span className="text-sm font-semibold text-gray-800">
            Input Data (JSON)
          </span>
        </div>
        <button
          onClick={onReset}
          className="text-xs font-medium text-gray-500 hover:text-gray-700"
        >
          Reset
        </button>
      </div>

      {/* Fetch row */}
      <div className="flex items-center gap-2 border-b border-gray-100 px-4 py-3">
        <div className="flex-1">
          <TextInput
            label="Identifier ID"
            id="identifier-id-input"
            placeholder="Enter identifier ID..."
            hideLabel
            defaultValue={identifierId}
            onChange={({ value }: { value: string }) =>
              onIdentifierChange(value)
            }
          />
        </div>
        <Button
          buttonType="secondary"
          size="small"
          onClick={onFetch}
          disabled={!identifierId.trim() || isFetching}
        >
          {isFetching ? "Fetching..." : "Fetch"}
        </Button>
      </div>

      {/* JSON textarea */}
      <div className="flex flex-1 flex-col px-4 py-3">
        <textarea
          className="flex-1 resize-none rounded border border-gray-200 bg-gray-50 p-3 font-mono text-xs text-gray-800 outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400"
          style={{ minHeight: "280px" }}
          placeholder="Paste or type JSON input data here..."
          value={jsonInput}
          onChange={(e) => onJsonInputChange(e.target.value)}
          spellCheck={false}
        />
        {jsonParseError && (
          <div className="mt-2 text-xs text-red-500">{jsonParseError}</div>
        )}
      </div>

      {/* Run button */}
      <div className="border-t border-gray-100 px-4 py-3">
        <Button
          buttonType="primary"
          size="medium"
          onClick={onRun}
          disabled={!isJsonValid || isRunning}
        >
          {isRunning ? "Running..." : "Run"}
        </Button>
      </div>
    </div>
  );
};

export default InputPanel;
